module.exports = __webpack_public_path__ + "img/finish-matte-bronze.e097a65e.jpg";